module.exports = __webpack_public_path__ + "static/logo-96e6f2707ac9181f7b1df15cbe63e06d.png";